import React from 'react';

import ReportsListTemplate from 'src/components/ReportsListTemplate';

const ReportsList = (props: Record<string, unknown>) => (
  <ReportsListTemplate {...props} />
);

export default ReportsList;
